import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import MaterialStyleContent from "./MaterialStyleContent";
import MaterialStyleNav from "./MaterialStyleNav";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { MaterialStyleTabTitle } from "../../../../Constants/Constants";
import { MaterialStyleSubTitle } from "../../../../Data/UiKits/Tabs";

const MaterialStyleTab = () => {
  const [basicTab, setBasicTab] = useState("1");

  return (
    <Col xxl="6">
      <Card>
        <CommonCardHeader title={MaterialStyleTabTitle} span={MaterialStyleSubTitle} />
        <CardBody>
          <MaterialStyleNav basicTab={basicTab} setBasicTab={setBasicTab} />
          <MaterialStyleContent tabId={basicTab} />
        </CardBody>
      </Card>
    </Col>
  );
};
export default MaterialStyleTab;
